import $ from 'jquery'

export class ProgressBar {
  constructor() {
    this.$progressBar = $('.progress-bar')

    if (this.$progressBar.length === 0) return

    this.$progressBar.each(this.handleProgressBar.bind(this))
    $(window).on('scroll', this.handleProgressBar.bind(this))
  }

  handleProgressBar() {
    let $bar = this.$progressBar.find('div')
    let scrollTop = $(window).scrollTop()
    let windowHeight = $(window).height()
    let documentHeight = $('header.header').height() + $('main').height()
    let progress = (scrollTop / (documentHeight - windowHeight * 2 / 3)) * 100

    if (progress > 100) {
      $bar.css('width', '100%')
      $bar.css('transform', 'translateY(-105%)')
    } else {
      $bar.css('transform', 'translateY(0)')
      $bar.css('width', `${progress}%`)
    }
  }
}
